import script from "./InputAmountPerformance.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputAmountPerformance.vue?vue&type=script&setup=true&lang=ts"

import "./InputAmountPerformance.vue?vue&type=style&index=0&id=06dd6245&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06dd6245"]])

export default __exports__